import { createContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserService from "../services/UserService";
export const AuthContext = createContext({
    userData: {},
    logOut: () => {},
    getData: () => {}
});
export default function AuthProvider({ children }) {
    const [userData, setUserData] = useState({});
    const navigate = useNavigate();
    const getData = () => {
        UserService.getUserData().then((res) => {
            if (res && res.data) {
                setUserData({
                    firstName: res.data.firstName || "",
                    lastName: res.data.lastName || "",
                    userName: res.data.userName || "",
                    email: res.data.email || "",
                    lastLogIn: res.data.lastLogIn || ""
                });
            } 
            else {
                setUserData({});
            }
        })
        .catch(() => {
            setUserData({});
        });
    };
    useEffect(() => {
        getData();
    }, []);
    const logOut = async () => {
        try {
            await UserService.logOut();
        } 
        catch (error) {
            if (error.response?.status === 401) {
                console.warn("User was already logged out.");
            } 
            else {
                console.error("Logout error:", error);
            }
        } 
        finally {
            setUserData({});
            navigate("/");
        }
    };
    return (
        <AuthContext.Provider value={{ userData, logOut, getData }}>
            {children}
        </AuthContext.Provider>
    );
}
